// Rozpozná, jak se školení otevře: YouTube a Loom se vloží do okna, ostatní odkazy (PDF,
// mapy, prezentace) se otevřou v novém panelu. YouTube umí říct, že video doběhlo do konce.
export function rozpoznejOdkaz(url) {
  const u = String(url || "").trim();
  if (!u) return { druh: "zadny" };
  let m = u.match(/(?:youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{11})/);
  if (!m) m = u.match(/[?&]v=([A-Za-z0-9_-]{11})/);
  if (m && /youtu/.test(u)) return { druh: "youtube", id: m[1], embed: `https://www.youtube-nocookie.com/embed/${m[1]}?enablejsapi=1&rel=0&modestbranding=1&playsinline=1` };
  const l = u.match(/loom\.com\/(?:share|embed)\/([a-f0-9]{32})/i);
  if (l) return { druh: "loom", id: l[1], embed: `https://www.loom.com/embed/${l[1]}` };
  return { druh: "jiny" };
}

/** Čísla modulů: moduly (bez rodiče) v pořadí, každému jeho přílohy. */
export function slozModuly(polozky) {
  const ids = new Set(polozky.map((p) => p.id));
  const razeni = (a, b) => (a.poradi || 0) - (b.poradi || 0) || a.id - b.id;
  const prilohy = new Map();
  const moduly = [];
  for (const p of [...polozky].sort(razeni)) {
    if (p.parent_id && ids.has(p.parent_id)) {
      if (!prilohy.has(p.parent_id)) prilohy.set(p.parent_id, []);
      prilohy.get(p.parent_id).push(p);
    } else moduly.push(p);
  }
  return moduly.map((m) => ({ ...m, prilohy: prilohy.get(m.id) || [] }));
}

/** Název bez úvodu „Modul 3: “ a „Příloha, modul 3: “. */
export const kratkyNazev = (n) => String(n || "").replace(/^Příloha, modul \d+: /, "").replace(/^Modul \d+: /, "");
